/**
 * FILTER theme functions
 */
const DC = {
    abstractInitialized: false,



    onReady: () => {
        DC.searchForm = document.getElementById('form-search-datacite');
        DC.filterForm = document.getElementById('form-filter-datacite');

        if ( DC.searchForm != null ) {
            DC.searchForm.addEventListener("submit", function(e) {
                e.preventDefault();
                DC.initSubmit(e);
            });  

            DC.triggerSearchbyUrl();
            
            if ( DC.filterForm != null ) {
                DC.initFilter();
            }
        }
    },



    triggerSearchbyUrl: () => {
        const params = new URLSearchParams(window.location.search);
        
        // trigger form
        if ( params.has('sn-searchquery') ) {
            // Einen echten Submit-Event simulieren
            const submitEvent = new Event('submit', {
                bubbles: true,
                cancelable: true
            });
            DC.searchForm.dispatchEvent(submitEvent);
        }
    },



    initSubmit: (event) => {
        event.preventDefault();
        DC.event   = event;
        DC.context = document.querySelector('#datacite');

        // if ( DC.searchForm.querySelector('#sn-searchquery').value.trim() === '' ) 
        //     return;


        // Reset filter
        if ( DC.filterForm != null ) {
            const checkboxes = DC.filterForm.querySelectorAll('.filter-item');

            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
        }

        DC.sendForm();
    },


    sendForm: () => {    
        const action = DC.searchForm.dataset.action || DC.searchForm.action;
        const body = new FormData(DC.filterForm);
        body.append("sn-searchquery", DC.searchForm.querySelector('#sn-searchquery').value);

        DC.context.querySelector('.loader').classList.remove('is-hidden')

        fetch(action, {
            method: 'POST',
            body,
            credentials: "same-origin",
            headers: {
              "X-WP-Nonce": dcJS.nonce,
            },
        })
        .then(function(response) {
            return response.json()
        })
        .then(function(response) {
            if ( ! response || typeof response.html_results === 'undefined' ) {
                throw new Error('Invalid DataCite response');
            }

            DC.context.querySelector('#datacite-results-list').innerHTML = '';
            DC.context.querySelector('#datacite-results-list').insertAdjacentHTML("beforeend", response.html_results || '');
            
            if ( 
                response.rows >= 1 
                // && response.searchquery != DC.searchForm.querySelector('#sn-searchquery').value 
                // && response.filter == 0
            ) {
                DC.context.querySelector('#form-filter-datacite .filter').innerHTML = '';
                DC.context.querySelector('#form-filter-datacite .filter').insertAdjacentHTML("beforeend", response.html_filter || '');
                DC.context.querySelector('#form-filter-datacite button').classList.remove('is-hidden');
                DC.toggleFilterLayout(true);
            
            } else {
                DC.context.querySelector('#form-filter-datacite .filter').innerHTML = '';
                DC.context.querySelector('#form-filter-datacite button').classList.add('is-hidden');
                DC.toggleFilterLayout(false);

            }

            DC.toggleFilter();
            DC.initAbstract();
            

            DC.context.querySelector('.loader').classList.add('is-hidden');
            // DC.context.querySelector('#layer').classList.add('is-hidden');
            
    //         // history.replaceState('data to be passed', 'Title of the page', '/test');
        })
        .catch((error) => {
            console.log('Server error: ' + error);

        //     DC.context.querySelectorAll('.notification.is-danger').forEach((el) => {
        //         el.innerHTML += '<br /><em>' + error + '</em>';
        //         el.classList.remove('is-hidden');
        //     });
            
        //     DC.context.querySelector('#layer').classList.add('is-hidden');
        })
        ;
    },



    toggleFilterLayout: (hasResults) => {
        const filterLayout = DC.context.querySelector('.section-datacite') || DC.context;

        filterLayout.classList.toggle('has-filter', hasResults);
    },



    initFilter: () => {
        // DC.filterForm.addEventListener('change', DC.sendForm);

        DC.filterForm.addEventListener("submit", function(e) {
            e.preventDefault();
            DC.sendForm();
        });

        DC.toggleFilter();
    },



    toggleFilter: () => {
        const maxHeight = 308;

        document.querySelectorAll('.filter-items').forEach((container, index) => {
            const fullHeight = container.scrollHeight;

            if (fullHeight > maxHeight) {
                const containerId = container.id || `filter-items-${index}`;
                container.id = containerId;

                // Startzustand: begrenzt + Verlauf sichtbar
                container.style.maxHeight = maxHeight + 'px';
                container.classList.add('collapsed');

                const link = document.createElement('a');
                link.textContent = 'Alles anzeigen';
                link.href = '#';
                link.className = 'show-more-link';
                link.setAttribute('role', 'button');
                link.setAttribute('aria-expanded', 'false');
                link.setAttribute('aria-controls', containerId);
                link.setAttribute('tabindex', '0');

                container.insertAdjacentElement('afterend', link);

                let expanded = false;

                function toggle(e) {
                    if (e) 
                        e.preventDefault();

                    expanded = !expanded;

                    if (expanded) {
                        container.style.maxHeight = fullHeight + 'px';
                        container.classList.remove('collapsed');
                        link.textContent = 'Verbergen';
                        link.setAttribute('aria-expanded', 'true');
                    } else {
                        container.style.maxHeight = maxHeight + 'px';
                        container.classList.add('collapsed');
                        link.textContent = 'Alles anzeigen';
                        link.setAttribute('aria-expanded', 'false');
                        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }

                link.addEventListener('click', toggle);
                link.addEventListener('keydown', e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        toggle(e);
                    }
                });
            }
        });
    },



    initAbstract: () => {
        if ( DC.abstractInitialized ) 
            return;

        const container = DC.context.querySelector('#datacite-results-list');

        DC.abstractInitialized = true;
        
        container.addEventListener('click', e => {
            const item = e.target.closest('.dc-show-abstract');
            if (item && container.contains(item)) {
                e.preventDefault();

                DC.getAbstract(item);
            }

        });
    },



    getAbstract: (item) => {
        if ( item.dataset.loading === 'true' )
            return;

        const action = dcJS.restUrl + '/abstract/' + item.dataset.id + '/';
        const method = 'get';
        const abstractBox = item.closest('.dc-abstract');
        const abstractTarget = abstractBox.querySelector('.the-abstract') || abstractBox;
        const defaultText = item.dataset.defaultText || item.textContent;
        const toggleText = item.dataset.toggleText || defaultText;

        item.dataset.defaultText = defaultText;

        if ( item.dataset.loaded === 'true' ) {
            DC.toggleAbstract(item, abstractTarget, defaultText, toggleText);
            return;
        }

        item.dataset.loading = 'true';

        DC.context.querySelector('.loader').classList.remove('is-hidden')


        fetch(action, {
            method,
            credentials: "same-origin",
            headers: {
              "X-WP-Nonce": dcJS.nonce,
            },
        })
        .then(function(response) {
            return response.json()
        })
        .then(function(response) {
            // console.log(response);

            abstractTarget.innerHTML = response.html_abstract;
            // abstractBox.closest('.teaser-publication.datacite').scrollIntoView({ behavior: 'smooth', block: 'start' });

            item.dataset.loaded = 'true';
            item.dataset.loading = 'false';
            DC.showAbstract(item, abstractTarget, toggleText);

            DC.context.querySelector('.loader').classList.add('is-hidden');
        })
        .catch((error) => {
            console.log('Server error: ' + error);
            item.dataset.loading = 'false';
            DC.context.querySelector('.loader').classList.add('is-hidden');
        });
    },



    showAbstract: (item, abstractTarget, toggleText) => {
        abstractTarget.classList.remove('is-hidden');
        item.textContent = toggleText;
        item.setAttribute('aria-expanded', 'true');
    },



    hideAbstract: (item, abstractTarget, defaultText) => {
        abstractTarget.classList.add('is-hidden');
        item.textContent = defaultText;
        item.setAttribute('aria-expanded', 'false');
    },



    toggleAbstract: (item, abstractTarget, defaultText, toggleText) => {
        if ( abstractTarget.classList.contains('is-hidden') ) {
            DC.showAbstract(item, abstractTarget, toggleText);
            return;
        }

        DC.hideAbstract(item, abstractTarget, defaultText);
    }
}

window.addEventListener('DOMContentLoaded', () => {
    DC.onReady();
});
